import logo from "../assets/images/logoWhite.png";
import { useNavigate, Outlet, useLocation, Link as RouterLink } from "react-router-dom";
import { useStateContext } from "../context/ContextProvider";
import { useEffect, useState } from "react";
import axiosClient, { linkImage } from "../axios-client";
import { FaChevronCircleLeft, FaStickyNote, FaUser, FaUserFriends, FaUserTie, FaYoutube } from "react-icons/fa";
import { BsFillInfoCircleFill, BsHousesFill, BsPersonVcardFill } from "react-icons/bs";
import { FaUserEdit } from "react-icons/fa";
import { FaCloudArrowDown, FaMapLocationDot, FaSackDollar, FaShop } from "react-icons/fa6";
import { HiCursorClick } from "react-icons/hi";
import LanguageChanger from "../components/language/LanguageChanger";
import { useTranslation } from "react-i18next";
import { PiDotOutline } from "react-icons/pi";
import { ImStatsBars } from "react-icons/im";


import { BiCategory, BiCategoryAlt, BiLogOut, BiMessageSquareDetail, BiSolidUser, BiSupport } from "react-icons/bi";

import {
  IconButton,
  Avatar,
  Box,
  CloseButton,
  Flex,
  Image,
  HStack,
  Center,
  VStack,
  Icon,
  useColorModeValue,
  Drawer,
  DrawerContent,
  Text,
  useDisclosure,
  Menu,
  MenuButton,
  MenuDivider,
  MenuItem,
  MenuList,
  useColorMode,
  Badge,
  Divider,
  AccordionItem,
  Accordion,
  AccordionPanel,
  List,
  ListItem,
  AccordionButton,
  Link,
  Card,
  CardBody,
  Heading,
  useToast,
} from "@chakra-ui/react";
import {
  FiHome,
  FiMenu,
  FiMoon,
  FiSun,
  FiChevronDown,
  FiChevronRight,
} from "react-icons/fi";
import { MdEventNote, MdNotificationsActive, MdOutlineNotificationsActive, MdPayments, MdSubscriptions, MdStore } from "react-icons/md";
import { ChevronDownIcon, SettingsIcon } from "@chakra-ui/icons";
import { GoAlertFill, GoDot } from "react-icons/go";
import { IoCartOutline } from "react-icons/io5";
import { RiCoupon3Fill, RiMenuFoldLine, RiMenuUnfoldLine, RiShoppingCartFill } from "react-icons/ri";
import { IoMdPricetags } from "react-icons/io";
import FormattedNumber from "./FormattedNumber";

export default function DefaultLayout() {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [isSiderBar, setIsSideBar] = useState("block");
  const [changedWidth, setChangedWidth] = useState("280px");
  const { user } = useStateContext();

  const handleCloseSideBar = () => {
    if (isSiderBar === "block") {
      setIsSideBar("none");
      setChangedWidth("full");
    } else {
      setIsSideBar("block");
      setChangedWidth("280px");
    }
  };
  const location = useLocation();

  // Define a list of paths where padding should be removed.
  const pathsWithNoPadding = ['/ajouter-evenement', '/modifier-evenement', '/partenaires-signales'];
  // const pathsWithNoPadding2 = ['/modifier-evenement'];
  // const pathsWithNoPadding3 = ['/partenaires-signalés'];


  const paddingValue = pathsWithNoPadding.includes(location.pathname) ? '0' : '4';
  return (
    <Box minH="100vh" bg={useColorModeValue("#f8f9fb", "gray.900")}>
      <SidebarContent
        onClose={() => onClose}
        display={{ base: "none", md: isSiderBar }}
      />

      <Drawer
        autoFocus={false}
        isOpen={isOpen}
        placement="left"
        onClose={onClose}
        returnFocusOnClose={false}
        onOverlayClick={onClose}
        size="full"
      >
        <DrawerContent>
          <SidebarContent onClose={onClose} />
        </DrawerContent>
      </Drawer>
      {/* mobilenav */}


      <MobileNav
        onOpen={onOpen}
        handleCloseSideBar={handleCloseSideBar}
        isSiderBar={isSiderBar}
      />

      <Box
        ml={{ base: 0, md: changedWidth }}
        p={paddingValue}
        transition="margin-left 0.3s cubic-bezier(0.4, 0, 0.2, 1)"
        minH="calc(100vh - 80px)"
        pt={paddingValue === '0' ? '0' : '6'}
      >
        <Box className="animate-fade-in">
          <Outlet />
        </Box>
      </Box>


    </Box>
  );
}

const SidebarContent = ({ onClose, ...rest }) => {
  const { user, setToken, setUser, currentBusiness, setCurrentBusiness, updateTicketCount } = useStateContext();
  const userRole = user.role;
  const { t } = useTranslation();
  const navigate = useNavigate();

  // Fetch ticket count once when sidebar mounts or user changes
  useEffect(() => {
    if (user?.id) {
      updateTicketCount();
    }
  }, [user?.id]);

  // current user data


  const LinkItems = {
    ///////////////////////////////////// ADMIN LINKS /////////////////////////////////////
    Admin: [
      { name: t("Tableau de bord"), icon: FiHome, path: "/" },
      { name: t("Gestion Utilisateurs"), icon: FaUserTie, path: "/mes-utilisateurs" },
      { name: t("Gestion Clients"), icon: FaUser, path: "/clients" },
      { name: t("Demandes d'inscription"), icon: BsPersonVcardFill, path: "/demandes-inscription" },
      { name: t("Demandes d'abonnement"), icon: MdPayments, path: "/demandes-abonnement" },
      { name: t("Plans d'abonnement"), icon: MdSubscriptions, path: "/admin/subscription-plans" },
      { name: t("Plateformes SaaS"), icon: MdStore, path: "/admin/platforms" },
      { name: t("Notifications"), icon: MdNotificationsActive, path: "/notifications" },
      { name: t("Tickets"), icon: BiMessageSquareDetail, path: "/tickets-admin" },
      { name: t("Tutoriels"), icon: FaYoutube, path: "/tutoriels-admin" },
      // { name: t("Gestion Admins"), icon: FaUserTie, path: "/admins" },
      // { name: t("Gestion Clients"), icon: FaUser, path: "/clients" },
      // { name: t("Gestion Partenaires"), icon: FaUserFriends, path: "/partenaires" },
      // { name: t("Réseau de Partenaires"), icon: FaMapLocationDot, path: "/localisations" },
      // { name: t("Partenaires Signalés"), icon: GoAlertFill, path: "/partenaires-signales" },

      // { name: t("Demandes d'inscription"), icon: BsPersonVcardFill, path: "/demandes-inscription" },
      // { name: t("Gestion Catégories"), icon: BiCategory, path: "/categories" },
      // { name: "Apa agency services", icon: BsHousesFill, path: "/apa-agency-services" },
      // { name: "Apa promotions", icon: SettingsIcon, path: "/apa-promotions" },
      // { name: t("Types d'abonnements"), icon: HiCursorClick, path: "/types_abonnements" },
      // { name: t("Espace Événements"), icon: MdEventNote, path: "/evenements" },
      // { name: "Notifications", icon: MdNotificationsActive, path: "/notifications" },
      // { name: "Tickets", icon: BiMessageSquareDetail, path: "/tickets" },
      // { name: t("A propos"), icon: BsFillInfoCircleFill, path: "/aPropos" },
      // { name: t("Paramètres"), icon: SettingsIcon, path: "/contacts" },

    ],
    Manager: [
      { name: t("Tableau de bord"), icon: FiHome, path: "/" },
      { name: t("Gestion Clients"), icon: FaUser, path: "/clients" },
      { name: t("Demandes d'inscription"), icon: BsPersonVcardFill, path: "/demandes-inscription" },
      { name: t("Demandes d'abonnement"), icon: MdPayments, path: "/demandes-abonnement" },
      { name: t("Plans d'abonnement"), icon: MdSubscriptions, path: "/admin/subscription-plans" },
      { name: t("Plateformes SaaS"), icon: MdStore, path: "/admin/platforms" },
      { name: t("Notifications"), icon: MdNotificationsActive, path: "/notifications" },
      { name: t("Tickets"), icon: BiMessageSquareDetail, path: "/tickets-admin" },
      { name: t("Tutoriels"), icon: FaYoutube, path: "/tutoriels-admin" },


    ],
    RespoSuivi: [
      { name: t("Tableau de bord"), icon: FiHome, path: "/" },
    ],
    StockManager: [
      { name: t("Tableau de bord"), icon: FiHome, path: "/" },
    ],

    ///////////////////////////////////// CLIENT LINKS /////////////////////////////////////

    AdminClient: [
      { name: t("Tableau de bord"), icon: FiHome, path: "/" },
      { name: t("Statistiques"), icon: ImStatsBars, path: "/statistics" },
      { name: t("Gestion Utilisateurs"), icon: FaUserTie, path: "/utilisateurs" },
      { name: t("Gestion Stock"), icon: RiShoppingCartFill, path: "/stock" },
      { name: t("Gestion Commandes"), icon: IoMdPricetags, path: "/orders" },
      { name: t("Gestion Plateformes"), icon: FaCloudArrowDown, path: "/apis" },
      { name: t("Tickets & Notes"), icon: FaStickyNote, path: "/gestion-requetes" },
      { name: t("Coupons"), icon: RiCoupon3Fill, path: "/coupons" },
      { name: t("Finance"), icon: MdPayments, path: "/finances" },
      { name: t("Support"), icon: BiSupport, path: "/ticket" },
      { name: t("Tutoriels"), icon: FaYoutube, path: "/tutoriels" },
    ],
    ManagerClient: [
      { name: t("Tableau de bord"), icon: FiHome, path: "/" },
      { name: t("Statistiques"), icon: ImStatsBars, path: "/statistics" },
      // { name: t("Gestion Utilisateurs"), icon: FaUserTie, path: "/utilisateurs" },
      { name: t("Gestion Stock"), icon: RiShoppingCartFill, path: "/stock" },
      { name: t("Gestion Commandes"), icon: IoMdPricetags, path: "/orders" },
      { name: t("Gestion Plateformes"), icon: FaCloudArrowDown, path: "/apis" },


      { name: t("Tickets & Notes"), icon: FaStickyNote, path: "/gestion-requetes" },
      { name: t("Coupons"), icon: RiCoupon3Fill, path: "/coupons" },
      { name: t("Finance"), icon: MdPayments, path: "/finances" },
      { name: t("Support"), icon: BiSupport, path: "/ticket" },
      { name: t("Tutoriels"), icon: FaYoutube, path: "/tutoriels" },
    ],
    RespoSuiviClient: [
      // { name: t("Tableau de bord"), icon: FiHome, path: "/" },
      { name: t("Gestion Commandes"), icon: IoMdPricetags, path: "/orders" },
      { name: t("Support"), icon: BiSupport, path: "/ticket" },
      { name: t("Tutoriels"), icon: FaYoutube, path: "/tutoriels" },

    ],
    StockManagerClient: [
      // { name: t("Tableau de bord"), icon: FiHome, path: "/" },
      { name: t("Gestion Commandes"), icon: IoMdPricetags, path: "/orders" },
      { name: t("Gestion Stock"), icon: RiShoppingCartFill, path: "/stock" },

      { name: t("Support"), icon: BiSupport, path: "/ticket" },
      { name: t("Tutoriels"), icon: FaYoutube, path: "/tutoriels" },

    ],
  };
  const items = LinkItems[userRole] || [];

  const onLogout = (ev) => {
    ev.preventDefault();
    setUser({});
    setToken(null);
    localStorage.removeItem("tokenExpirationTime");
    localStorage.removeItem("refreshTimeAdmin");
    localStorage.removeItem("role");
  };

  // ── Active business chip shown at bottom of sidebar ─────────────────────
  const bizChipColor = currentBusiness?.is_active ? "#10b981" : "#ef4444";

  return (
    <Box
      pl={{ base: 0, md: 3 }}
      py={{ base: 0, md: 3 }}
      transition="all 0.3s cubic-bezier(0.4, 0, 0.2, 1)"
      color="white"
      w={{ base: "full", md: "280px" }}
      pos="fixed"
      h="full"
      zIndex={1000}
      {...rest}
    >
      <Box
        borderRadius={{ base: 0, md: "20px" }}
        w={"100%"}
        h={"100%"}
        position="relative"
        overflow="hidden"
        bgGradient={useColorModeValue(
          "linear(to-b, #0f0720, #1a0a3e, #4a0e6b, #7c3aad)",
          "linear(to-b, #0c0518, #150a2e, #2d1156, #4a0e6b)"
        )}
        boxShadow="4px 0 32px -4px rgba(17, 10, 41, 0.35)"
        display="flex"
        flexDirection="column"
      >
        {/* Decorative gradient orb */}
        <Box
          position="absolute"
          top="-60px"
          right="-60px"
          w="180px"
          h="180px"
          borderRadius="full"
          bg="purple.500"
          opacity={0.08}
          filter="blur(60px)"
          pointerEvents="none"
        />
        <Box
          position="absolute"
          bottom="20%"
          left="-40px"
          w="120px"
          h="120px"
          borderRadius="full"
          bg="purple.400"
          opacity={0.06}
          filter="blur(50px)"
          pointerEvents="none"
        />

        {/* Logo area */}
        <Flex
          flexDirection={"column"}
          pt={6}
          pb={4}
          alignItems="center"
          mx="6"
          justifyContent="center"
          flexShrink={0}
        >
          <CloseButton
            display={{ base: "flex", md: "none" }}
            onClick={onClose}
            position={"absolute"}
            top={3}
            right={3}
            color="whiteAlpha.700"
            _hover={{ color: "white", bg: "whiteAlpha.200" }}
            borderRadius="lg"
            size="sm"
          />
          <Image
            rounded={'full'}
            src={logo}
            maxW="250px"
            maxH={{ base: "90px", md: "110px" }}
            objectFit="contain"
            filter="drop-shadow(0 4px 12px rgba(128, 90, 213, 0.3))"
          />
        </Flex>

        {/* Subtle separator */}
        <Box mx={6} mb={3}>
          <Box h="1px" bg="linear-gradient(90deg, transparent, rgba(255,255,255,0.12), transparent)" />
        </Box>

        {/* Active business chip */}
        {currentBusiness && (
          <Box
            mx={4}
            mb={3}
            px={3}
            py={2.5}
            borderRadius="12px"
            bg="whiteAlpha.50"
            border="1px solid"
            borderColor="whiteAlpha.100"
            cursor="pointer"
            onClick={() => navigate("/select-business")}
            transition="all 0.2s ease"
            _hover={{
              bg: "whiteAlpha.100",
              borderColor: "whiteAlpha.200",
              transform: "translateY(-1px)",
            }}
          >
            <Flex align="center" gap={2.5}>
              <Box
                w={2}
                h={2}
                borderRadius="full"
                bg={bizChipColor}
                flexShrink={0}
                boxShadow={`0 0 8px ${bizChipColor}`}
              />
              <Box flex={1} minW={0}>
                <Text fontSize="10px" fontWeight="600" color="whiteAlpha.500" lineHeight={1} letterSpacing="0.05em" textTransform="uppercase">
                  {t("Business actif")}
                </Text>
                <Text fontSize="13px" fontWeight="600" color="white" isTruncated mt={0.5}>
                  {currentBusiness.name}
                </Text>
              </Box>
              <Box
                p={1}
                borderRadius="md"
                bg="whiteAlpha.100"
                _groupHover={{ bg: "whiteAlpha.200" }}
              >
                <Text fontSize="xs" color="whiteAlpha.600">↔</Text>
              </Box>
            </Flex>
          </Box>
        )}

        {/* Navigation items */}
        <Box
          overflowY={"auto"}
          py={1}
          my={0}
          flex={1}
          css={{
            "&::-webkit-scrollbar": { width: "3px" },
            "&::-webkit-scrollbar-track": { background: "transparent" },
            "&::-webkit-scrollbar-thumb": {
              background: "rgba(255,255,255,0.1)",
              borderRadius: "10px",
            },
            scrollbarWidth: "thin",
            scrollbarColor: "rgba(255,255,255,0.1) transparent",
          }}
        >
          {items.map((link, key) => (
            <NavItem
              items={items}
              key={link.name}
              icon={link.icon}
              onClose={onClose}
            >
              {link.name}
            </NavItem>
          ))}
        </Box>

        {/* Bottom separator */}
        <Box mx={6} mt={2}>
          <Box h="1px" bg="linear-gradient(90deg, transparent, rgba(255,255,255,0.1), transparent)" />
        </Box>

        {/* Logout button */}
        <Flex
          justify={"center"}
          align="center"
          py={4}
          mx={4}
          mb={2}
          color={"whiteAlpha.600"}
          cursor="pointer"
          gap={2.5}
          borderRadius="12px"
          transition="all 0.2s ease"
          _hover={{
            color: "red.300",
            bg: "rgba(239, 68, 68, 0.08)",
          }}
          onClick={onLogout}
        >
          <BiLogOut size={18} />
          <Text fontSize="13px" fontWeight="500">{t("Déconnexion")}</Text>
        </Flex>
      </Box>
    </Box>
  );
};

const NavItem = ({ icon, children, items, onClose, ...rest }) => {
  const { user } = useStateContext()
  const navigate = useNavigate();
  const { setUser } = useStateContext();
  const { t } = useTranslation()
  const location = useLocation();
  const pathLink = items.find((e) => e.name === children);
  const { countTickets, countTicketsManager, countNotes } = useStateContext()

  const [accordionIndex, setAccordionIndex] = useState([]);

  useEffect(() => {
    let paths = [];
    if (children === t("Gestion Commandes")) {
      paths = ["/list_new_orders", "/New-Confirmed-Orders", "/my_orders", "/modifier-commandes-webhook", "/Gestion-confirmation", "/Gestion-stock", "/Gestion-suivi", "/Facture"];
    } else if (children === t("Gestion Stock")) {
      paths = ["/My_Stock", "/categories", "/all-stock"];
    } else if (children === t("Gestion Plateformes")) {
      paths = ["/mes-apis", "/shipping-apis"];
    } else if (children === t("Finance")) {
      paths = ["/charges", "/gestion-finances"];
    } else if (children === t("Tickets & Notes")) {
      paths = ["/notes", "/tickets", "/tickets-admin", "/gestion-requetes"];
    }

    if (paths.includes(location.pathname)) {
      setAccordionIndex([0]);
    }
  }, [location.pathname, children, t]);


  const isParentMenu = children === t("Gestion Commandes") ||
    children === t("Gestion Stock") ||
    children === t("Gestion Plateformes") ||
    children === t("Finance") ||
    children === t("Tickets & Notes");

  let subPaths = [];
  if (children === t("Gestion Commandes")) {
    subPaths = ["/list_new_orders", "/New-Confirmed-Orders", "/my_orders", "/modifier-commandes-webhook", "/Gestion-confirmation", "/Gestion-stock", "/Gestion-suivi", "/Facture"];
  } else if (children === t("Gestion Stock")) {
    subPaths = ["/My_Stock", "/categories", "/all-stock"];
  } else if (children === t("Gestion Plateformes")) {
    subPaths = ["/mes-apis", "/shipping-apis"];
  } else if (children === t("Finance")) {
    subPaths = ["/charges", "/gestion-finances"];
  } else if (children === t("Tickets & Notes")) {
    subPaths = ["/notes", "/tickets", "/tickets-admin", "/gestion-requetes"];
  }

  const isChildActive = subPaths.includes(location.pathname);
  const isExpanded = accordionIndex.includes(0);
  const isParentActiveOrExpanded = isParentMenu && (isExpanded || isChildActive);

  const handleClick = (e) => {
    if (pathLink && (pathLink.path === "/orders" || pathLink.path === "/stock" || pathLink.path === "/apis" || pathLink.path === "/finances" || pathLink.path === "/gestion-requetes")) {
      e.preventDefault();
      return;
    } else if (pathLink) {
      onClose();
    }
  };
if (isParentMenu) {
    return (
      <Box mx="3" my={0.5} {...rest}>
        <Accordion allowMultiple width="100%" borderColor="transparent" index={accordionIndex} onChange={(idx) => setAccordionIndex(idx)}>
          <AccordionItem bg="transparent" border="none" p={0} m={0}>
            <AccordionButton
              px="3"
              py="2.5"
              rounded="12px"
              bg="transparent"
              boxShadow="none"
              color={isParentActiveOrExpanded ? "white" : "whiteAlpha.800"}
              _hover={{ bg: "whiteAlpha.100" }}
              display="flex"
              alignItems="center"
              justifyContent="space-between"
              transition="all 0.2s cubic-bezier(0.4, 0, 0.2, 1)"
            >
              <Flex align="center">
                {icon && (
                  <Icon
                    as={icon}
                    mr="3"
                    fontSize="17px"
                    color={isParentActiveOrExpanded ? "white" : "whiteAlpha.700"}
                    transition="all 0.2s ease"
                  />
                )}
                <Text
                  fontSize="13px"
                  fontWeight={isParentActiveOrExpanded ? "700" : "500"}
                  letterSpacing="-0.01em"
                  textAlign="left"
                >
                  {children}
                </Text>
              </Flex>
              <Icon
                as={isExpanded ? FiChevronDown : FiChevronRight}
                fontSize="16px"
                color={isParentActiveOrExpanded ? "white" : "whiteAlpha.500"}
                transition="all 0.2s ease"
              />
            </AccordionButton>

            <AccordionPanel rounded="xl" p={0} m={0} pt={1} pl={2} w="100%">
              <Flex align="center">
                <List mt={2} mb={1} spacing={2} w="100%">
                  {children === t("Gestion Commandes") && (
                    <>
                      {["AdminClient", "ManagerClient", "RespoSuiviClient"].includes(user.role) && <ListItem w={"100%"}>
                        <Flex
                          align="center"
                          gap={1}
                          mx="1"
                          rounded={"xl"}
                          fontSize={location.pathname === "/list_new_orders" ? "15" : "14"}
                          fontWeight={location.pathname === "/list_new_orders" ? "semibold" : ""}
                          as={RouterLink} to="/list_new_orders" onClick={() => onClose()}
                          cursor="pointer"
                        >
                          <PiDotOutline color={location.pathname === "/list_new_orders" ? "white" : "rgb(255 255 255 / 39%)"} size={24} />
                          {t("Nouvelles commandes")}
                        </Flex>
                      </ListItem>}

                      {["StockManagerClient"].includes(user.role) && <ListItem w={"100%"}>
                        <Flex
                          align="center"
                          gap={1}
                          mx="1"
                          rounded={"xl"}
                          fontSize={location.pathname === "/New-Confirmed-Orders" ? "15" : "14"}
                          fontWeight={location.pathname === "/New-Confirmed-Orders" ? "semibold" : ""}
                          as={RouterLink} to="/New-Confirmed-Orders" onClick={() => onClose()}
                          cursor="pointer"
                        >
                          <PiDotOutline color={location.pathname === "/New-Confirmed-Orders" ? "white" : "rgb(255 255 255 / 39%)"} size={24} />
                          {t("Nouvelles commandes confirmées")}
                        </Flex>
                      </ListItem>}

                      {["AdminClient", "ManagerClient"].includes(user.role) && <ListItem w={"100%"}>
                        <Flex
                          align="center"
                          gap={1}
                          mx="1"
                          rounded={"xl"}
                          fontSize={location.pathname === "/my_orders" ? "15" : "14"}
                          fontWeight={location.pathname === "/my_orders" ? "semibold" : ""}
                          as={RouterLink} to="/my_orders" onClick={() => onClose()}
                          cursor="pointer"
                        >
                          <PiDotOutline color={location.pathname === "/my_orders" ? "white" : "rgb(255 255 255 / 39%)"} size={24} />
                          {t("Mes commandes")}
                        </Flex>
                      </ListItem>}

                      {["AdminClient", "ManagerClient"].includes(user.role) && <ListItem w={"100%"}>
                        <Flex
                          align="center"
                          gap={1}
                          mx="1"
                          rounded={"xl"}
                          fontSize={location.pathname === "/modifier-commandes-webhook" ? "15" : "14"}
                          fontWeight={location.pathname === "/modifier-commandes-webhook" ? "semibold" : ""}
                          as={RouterLink} to="/modifier-commandes-webhook" onClick={() => onClose()}
                          cursor="pointer"
                        >
                          <PiDotOutline color={location.pathname === "/modifier-commandes-webhook" ? "white" : "rgb(255 255 255 / 39%)"} size={24} />
                          {t("Modifier via Webhook")}
                        </Flex>
                      </ListItem>}

                      {["RespoSuiviClient"].includes(user.role) && <ListItem w={"100%"}>
                        <Flex
                          align="center"
                          gap={1}
                          mx="1"
                          rounded={"xl"}
                          fontSize={location.pathname === "/Gestion-confirmation" ? "15" : "14"}
                          fontWeight={location.pathname === "/Gestion-confirmation" ? "semibold" : ""}
                          as={RouterLink} to="/Gestion-confirmation" onClick={() => onClose()}
                          cursor="pointer"
                        >
                          <PiDotOutline color={location.pathname === "/Gestion-confirmation" ? "white" : "rgb(255 255 255 / 39%)"} size={24} />
                          {t("Confirmation")}
                        </Flex>
                      </ListItem>}

                      {["StockManagerClient"].includes(user.role) && <ListItem w={"100%"}>
                        <Flex
                          align="center"
                          gap={1}
                          mx="1"
                          rounded={"xl"}
                          fontSize={location.pathname === "/Gestion-stock" ? "15" : "14"}
                          fontWeight={location.pathname === "/Gestion-stock" ? "semibold" : ""}
                          as={RouterLink} to="/Gestion-stock" onClick={() => onClose()}
                          cursor="pointer"
                        >
                          <PiDotOutline color={location.pathname === "/Gestion-stock" ? "white" : "rgb(255 255 255 / 39%)"} size={24} />
                          {t("Stock")}
                        </Flex>
                      </ListItem>}

                      {["RespoSuiviClient"].includes(user.role) && (
                        <>
                          <ListItem w={"100%"}>
                            <Flex
                              align="center"
                              gap={1}
                              mx="1"
                              rounded={"xl"}
                              fontSize={location.pathname === "/Gestion-suivi" ? "15" : "14"}
                              fontWeight={location.pathname === "/Gestion-suivi" ? "semibold" : ""}
                              as={RouterLink} to="/Gestion-suivi" onClick={() => onClose()}
                              cursor="pointer"
                            >
                              <PiDotOutline color={location.pathname === "/Gestion-suivi" ? "white" : "rgb(255 255 255 / 39%)"} size={24} />
                              {t("Suivi de commande")}
                            </Flex>
                          </ListItem>
                          <ListItem w={"100%"}>
                            <Flex
                              align="center"
                              gap={1}
                              mx="1"
                              rounded={"xl"}
                              fontSize={location.pathname === "/Facture" ? "15" : "14"}
                              fontWeight={location.pathname === "/Facture" ? "semibold" : ""}
                              as={RouterLink} to="/Facture" onClick={() => onClose()}
                              cursor="pointer"
                            >
                              <PiDotOutline color={location.pathname === "/Facture" ? "white" : "rgb(255 255 255 / 39%)"} size={24} />
                              {t("Facture")}
                            </Flex>
                          </ListItem>
                        </>
                      )}
                    </>
                  )}

                  {children === t("Gestion Stock") && (
                    <>
                      <ListItem w={"100%"}>
                        <Flex
                          align="center"
                          gap={1}
                          mx="1"
                          rounded={"xl"}
                          fontSize={location.pathname === "/My_Stock" ? "15" : "14"}
                          fontWeight={location.pathname === "/My_Stock" ? "semibold" : ""}
                          as={RouterLink} to="/My_Stock" onClick={() => onClose()}
                          cursor="pointer"
                        >
                          <PiDotOutline color={location.pathname === "/My_Stock" ? "white" : "rgb(255 255 255 / 39%)"} size={24} />
                          {t("Produits")}
                        </Flex>
                      </ListItem>

                      <ListItem w={"100%"}>
                        <Flex
                          align="center"
                          gap={1}
                          mx="1"
                          rounded={"xl"}
                          fontSize={location.pathname === "/categories" ? "15" : "14"}
                          fontWeight={location.pathname === "/categories" ? "semibold" : ""}
                          as={RouterLink} to="/categories" onClick={() => onClose()}
                          cursor="pointer"
                        >
                          <PiDotOutline color={location.pathname === "/categories" ? "white" : "rgb(255 255 255 / 39%)"} size={24} />
                          {t("Catégories")}
                        </Flex>
                      </ListItem>

                      <ListItem w={"100%"}>
                        <Flex
                          align="center"
                          gap={1}
                          mx="1"
                          rounded={"xl"}
                          fontSize={location.pathname === "/all-stock" ? "15" : "14"}
                          fontWeight={location.pathname === "/all-stock" ? "semibold" : ""}
                          as={RouterLink} to="/all-stock" onClick={() => onClose()}
                          cursor="pointer"
                        >
                          <PiDotOutline color={location.pathname === "/all-stock" ? "white" : "rgb(255 255 255 / 39%)"} size={24} />
                          {t("Stock Global")}
                        </Flex>
                      </ListItem>
                    </>
                  )}

                  {children === t("Gestion Plateformes") && (
                    <>
                      <ListItem w={"100%"}>
                        <Flex
                          align="center"
                          gap={1}
                          mx="1"
                          rounded={"xl"}
                          fontSize={location.pathname === "/mes-apis" ? "15" : "14"}
                          fontWeight={location.pathname === "/mes-apis" ? "semibold" : ""}
                          as={RouterLink} to="/mes-apis" onClick={() => onClose()}
                          cursor="pointer"
                        >
                          <PiDotOutline color={location.pathname === "/mes-apis" ? "white" : "rgb(255 255 255 / 39%)"} size={24} />
                          {t("Plateformes e-store")}
                        </Flex>
                      </ListItem>

                      <ListItem w={"100%"}>
                        <Flex
                          align="center"
                          gap={1}
                          mx="1"
                          rounded={"xl"}
                          fontSize={location.pathname === "/shipping-apis" ? "15" : "14"}
                          fontWeight={location.pathname === "/shipping-apis" ? "semibold" : ""}
                          as={RouterLink} to="/shipping-apis" onClick={() => onClose()}
                          cursor="pointer"
                        >
                          <PiDotOutline color={location.pathname === "/shipping-apis" ? "white" : "rgb(255 255 255 / 39%)"} size={24} />
                          {t("Plateformes livraison")}
                        </Flex>
                      </ListItem>
                    </>
                  )}

                  {children === t("Finance") && (
                    <>
                      <ListItem w={"100%"}>
                        <Flex
                          align="center"
                          gap={1}
                          mx="1"
                          rounded={"xl"}
                          fontSize={location.pathname === "/charges" ? "15" : "14"}
                          fontWeight={location.pathname === "/charges" ? "semibold" : ""}
                          as={RouterLink} to="/charges" onClick={() => onClose()}
                          cursor="pointer"
                        >
                          <PiDotOutline color={location.pathname === "/charges" ? "white" : "rgb(255 255 255 / 39%)"} size={24} />
                          {t("Charges")}
                        </Flex>
                      </ListItem>

                      <ListItem w={"100%"}>
                        <Flex
                          align="center"
                          gap={1}
                          mx="1"
                          rounded={"xl"}
                          fontSize={location.pathname === "/gestion-finances" ? "15" : "14"}
                          fontWeight={location.pathname === "/gestion-finances" ? "semibold" : ""}
                          as={RouterLink} to="/gestion-finances" onClick={() => onClose()}
                          cursor="pointer"
                        >
                          <PiDotOutline color={location.pathname === "/gestion-finances" ? "white" : "rgb(255 255 255 / 39%)"} size={24} />
                          {t("Gestion Facture")}
                        </Flex>
                      </ListItem>
                    </>
                  )}

                  {children === t("Tickets & Notes") && (
                    <>
                      <ListItem w={"100%"}>
                        <Flex
                          align="center"
                          justifyContent="space-between"
                          gap={1}
                          mx="1"
                          rounded={"xl"}
                          fontSize={location.pathname === "/notes" ? "15" : "14"}
                          fontWeight={location.pathname === "/notes" ? "semibold" : ""}
                          as={RouterLink} to="/notes" onClick={() => onClose()}
                          cursor="pointer"
                        >
                          <Flex align="center">
                            <PiDotOutline color={location.pathname === "/notes" ? "white" : "rgb(255 255 255 / 39%)"} size={24} />
                            Notes
                          </Flex>
                          {countNotes > 0 && (
                            <Badge
                              rounded="full"
                              bg="#df2e38"
                              style={{ padding: "2px 7px 2px 6px" }}
                              color="white"
                              ml="2"
                            >
                              {countNotes}
                            </Badge>
                          )}
                        </Flex>
                      </ListItem>

                      <ListItem w={"100%"}>
                        <Flex
                          align="center"
                          justifyContent="space-between"
                          gap={1}
                          mx="1"
                          rounded={"xl"}
                          fontSize={location.pathname === "/tickets" ? "15" : "14"}
                          fontWeight={location.pathname === "/tickets" ? "semibold" : ""}
                          as={RouterLink} to="/tickets" onClick={() => onClose()}
                          cursor="pointer"
                        >
                          <Flex align="center">
                            <PiDotOutline color={location.pathname === "/tickets" ? "white" : "rgb(255 255 255 / 39%)"} size={24} />
                            {t("Tickets")}
                          </Flex>
                          {(countTickets > 0 && user.role === "AdminClient") && (
                            <Badge
                              rounded="full"
                              bg="#df2e38"
                              style={{ padding: "2px 7px 2px 6px" }}
                              color="white"
                              ml="2"
                            >
                              {countTickets}
                            </Badge>
                          )}
                          {(countTicketsManager > 0 && user.role === "ManagerClient") && (
                            <Badge
                              rounded="full"
                              bg="#df2e38"
                              style={{ padding: "2px 7px 2px 6px" }}
                              color="white"
                              ml="2"
                            >
                              {countTicketsManager}
                            </Badge>
                          )}
                        </Flex>
                      </ListItem>
                    </>
                  )}
                </List>
              </Flex>
            </AccordionPanel>
          </AccordionItem>
        </Accordion>
      </Box>
    );
  }

  return (
    <Box
      as={pathLink ? RouterLink : "div"}
      to={pathLink ? pathLink.path : undefined}
      onClick={handleClick}
      style={{ textDecoration: "none" }}
      _focus={{ boxShadow: "none" }}
      display="block"
    >
      <Flex
        align="center"
        mx="3"
        px="3"
        py="2.5"
        my={0.5}
        rounded="12px"
        bg={pathLink && pathLink.path === location.pathname ? "whiteAlpha.150" : "transparent"}
        borderLeft={pathLink && pathLink.path === location.pathname ? "3px solid" : "3px solid transparent"}
        borderColor={pathLink && pathLink.path === location.pathname ? "purple.300" : "transparent"}
        fontWeight={pathLink && pathLink.path === location.pathname ? "600" : "400"}
        role="group"
        cursor="pointer"
        transition="all 0.2s cubic-bezier(0.4, 0, 0.2, 1)"
        _hover={{
          bg: "whiteAlpha.100",
        }}
        {...rest}
      >
        {icon && (
          <Icon
            bg={pathLink && pathLink.path === location.pathname ? "whiteAlpha.200" : "transparent"}
            p={pathLink && pathLink.path === location.pathname ? 1.5 : 0}
            rounded={pathLink && pathLink.path === location.pathname ? "8px" : ""}
            mr="3"
            fontSize={pathLink && pathLink.path === location.pathname ? "28" : "17"}
            color={pathLink && pathLink.path === location.pathname ? "white" : "whiteAlpha.700"}
            transition="all 0.2s ease"
            _groupHover={{
              color: "white",
            }}
            as={icon}
          />
        )}
        {children === "Tickets" ? (
          <>
            <Box flex="1">
              <Text
                fontSize={pathLink && pathLink.path === location.pathname ? "13.5px" : "13px"}
                color={pathLink && pathLink.path === location.pathname ? "white" : "whiteAlpha.700"}
                _groupHover={{ color: "white" }}
                transition="color 0.15s ease"
              >
                {children}
              </Text>
            </Box>
            {(countTickets > 0 && user.role === "AdminClient") && (
              <Badge
                rounded="full"
                bg="#df2e38"
                style={{ padding: "2px 7px 2px 6px" }}
                color="white"
                ml="2"
                fontSize="10px"
                boxShadow="0 0 6px rgba(223, 46, 56, 0.3)"
              >
                {countTickets}
              </Badge>
            )}
            {(countTicketsManager > 0 && user.role === "ManagerClient") && (
              <Badge
                rounded="full"
                bg="#df2e38"
                style={{ padding: "2px 7px 2px 6px" }}
                color="white"
                ml="2"
                fontSize="10px"
                boxShadow="0 0 6px rgba(223, 46, 56, 0.3)"
              >
                {countTicketsManager}
              </Badge>
            )}
          </>
        ) : (
          <Text
            fontSize={pathLink && pathLink.path === location.pathname ? "13.5px" : "13px"}
            color={pathLink && pathLink.path === location.pathname ? "white" : "whiteAlpha.700"}
            _groupHover={{ color: "white" }}
            transition="color 0.15s ease"
            letterSpacing="-0.01em"
          >
            {children}
          </Text>
        )}
      </Flex>
    </Box>
  );
};

const MobileNav = ({ onOpen, handleCloseSideBar, isSiderBar, ...rest }) => {
  const { user, setToken, setUser, count, setCount, countNotes, setCountNotes, currentBusiness, setCurrentBusiness } = useStateContext();
  const { colorMode, toggleColorMode } = useColorMode();
  const { t } = useTranslation()
  const [notifs, setNotifs] = useState([]);
  const [notes, setNotes] = useState([]);
  const navigate = useNavigate();
  const toast = useToast();

  const onLogout = (ev) => {
    ev.preventDefault();
    setUser({});
    setToken(null);
    setCurrentBusiness(null);
    localStorage.removeItem("tokenExpirationTime");
    localStorage.removeItem("refreshTimeAdmin");
    localStorage.removeItem("role");
  };
  const [changeBgNavBar, setChangeBgNavBar] = useState('white')

  const getUserNotifs = async () => {
    try {
      await axiosClient
        .get(`notifications/getUserNotifs/?page_size=7&page=1&userRole=${user?.role}&userId=${user?.id}&business=${currentBusiness?.id}`)
        .then((res) => {

          if (res.data.results) {
            setNotifs(res.data.results.notifs);

            setCount(res.data.results.count);

            if (res.data.error === 'Client is disabled.' && res.data.etat === false) {
              setUser({});
              setToken(null);
              localStorage.removeItem("tokenExpirationTime");
              localStorage.removeItem("refreshTimeAdmin");
              localStorage.removeItem("role");

              // Vérifier si le toast n'est pas déjà affiché
              if (!toast.isActive('accountDisabled')) {
                toast({
                  id: 'accountDisabled',
                  description: t("le compte est désactivé"),
                  status: 'warning',
                  variant: 'left-accent',
                  duration: 2000,
                  isClosable: true,
                  position: 'bottom-right'
                });
              }
            }
          }
        })
        .catch((error) => {
          // // console.error(error);
        });
    } catch (error) {
      // console.log('ERROR : ', error);

    }
  }

  const getUserNotes = async () => {
    try {
      await axiosClient
        .get(`notes/getUserNotes/?page_size=7&page=1&userRole=${user?.role}&userId=${user?.id}&business=${currentBusiness?.id}`)
        .then((res) => {
          if (res.data.results) {
            setNotes(res.data.results.notes);

            setCountNotes(res.data.results.count);
          }
        })
        .catch((error) => {
          // // console.error(error);
        });
    } catch (error) {
      // console.log('ERROR : ', error);
    }
  }

  useEffect(() => {
    if (user?.id) {

      getUserNotifs()

      getUserNotes()
    }

  }, [user?.id, count, countNotes]);

  function update() {
    if (user.id) {
      axiosClient
        .get(`notifications/getUserNotifs/?page_size=7&page=1&userRole=${user?.role}&userId=${user?.id}&business=${currentBusiness?.id}`)
        .then((res) => {
          setNotifs(res.data.results.notifs);

          setCount(res.data.results.count);

          if (res.data.error === 'Client is disabled.' && res.data.etat === false) {
            setUser({});
            setToken(null);
            localStorage.removeItem("tokenExpirationTime");
            localStorage.removeItem("refreshTimeAdmin");
            localStorage.removeItem("role");

            // Vérifier si le toast n'est pas déjà affiché
            if (!toast.isActive('accountDisabled')) {
              toast({
                id: 'accountDisabled',
                description: t("le compte est désactivé"),
                status: 'warning',
                variant: 'left-accent',
                duration: 2000,
                isClosable: true,
                position: 'bottom-right'
              });
            }
          }
        })
        .catch((error) => {
          // // console.error(error);
        });

      axiosClient
        .get(`notes/getUserNotes/?page_size=7&page=1&userRole=${user?.role}&userId=${user?.id}&business=${currentBusiness?.id}`)
        .then((res) => {
          setNotes(res.data.results.notes);

          setCountNotes(res.data.results.count);
        })
        .catch((error) => {
          // // console.error(error);
        });
    }
  }

  useEffect(() => {
    const onPageScroll = () => {
      if (window.pageYOffset > 50) {
        setChangeBgNavBar("#ffffff42");
      } else {
        setChangeBgNavBar("white");
      }
    };
    window.addEventListener("scroll", onPageScroll);

    return () => {
      window.removeEventListener("scroll", onPageScroll);
    };
  }, []);

  const IsReadNotif = (id) => {
    axiosClient.get(`/notifications/${id}/`)
      .then((response) => {
        const notification = response.data;

        if (!notification.is_read.includes(user.id)) {
          notification.is_read.push(user.id);

          axiosClient.put(`/notifications/${id}/`, {
            ...notification,
            is_read: notification.is_read,
          })
            .then((response) => {
              update()
              window.location.reload()
            })
            .catch((error) => {
              // // console.error(error)
            });
        }
      })
      .catch((error) => {
        // // console.error(error)
      });

  };

  const IsReadNote = (id) => {
    axiosClient.get(`/notes/${id}/`)
      .then((response) => {
        const note = response.data;

        if (!note.is_read.includes(user.id)) {
          note.is_read.push(user.id);

          axiosClient.put(`/notes/${id}/`, {
            ...note,
            is_read: note.is_read,
          })
            .then((response) => {
              update()
              window.location.reload()
            })
            .catch((error) => {
              // // console.error(error)
            });
        }
      })
      .catch((error) => {
        // // console.error(error)
      });

  };

  const colorCondition = useColorModeValue("black", "white")
  const notifBg = useColorModeValue("gray.100", "gray.600")
  const notifBgRead = useColorModeValue("white", "gray.700")
  const notifHover = useColorModeValue("gray.50", "gray.800")
  const txtColor = useColorModeValue('black', 'white')
  const boxShadowColor = useColorModeValue('rgba(0, 0, 0, 0.08)', 'rgba(255, 255, 255, 0.1)'); // Example of dynamic color based on color mode
  const menuItembg = useColorModeValue("gray.100", "gray.700")
  const bgPurpleColor = useColorModeValue("purple.50", "purple.900")
  const borderPurpleColor = useColorModeValue("purple.200", "purple.700")
  const hoverPurpleColor = useColorModeValue("purple.100", "purple.800")
  const txtColorPurpleBusinessName = useColorModeValue("purple.700", "white")
  const txtColorIconBusiness = useColorModeValue("purple.400", "white")
  const bg_hover = useColorModeValue("purple.50", "whiteAlpha.200")
  const boderColor_notif = useColorModeValue("gray.100", "gray.700")
  const bg_purple_notif = useColorModeValue("purple.50", "rgba(128, 90, 213, 0.1)")
  const bg_hover_purple = useColorModeValue("gray.50", "gray.700")
  const bg_hover_blue = useColorModeValue("blue.50", "rgba(49, 130, 206, 0.1)")
  const bg_blue_notif = useColorModeValue("blue.50", "whiteAlpha.200")
  const bg_hover_gray = useColorModeValue("gray.50", "gray.700")
  const navBarBgWhite = useColorModeValue("white", "gray.800")
  const navBarBgGlass = useColorModeValue("rgba(255,255,255,0.85)", "rgba(26,32,44,0.85)")
  const navBarBorderColor = useColorModeValue("gray.100", "gray.700")

  const flexContent = (
    <>



      {/* {isSiderBar === "block" ? (
        <>
          <Text  as="cite" ml={10} fontSize={{ base: "18px", md: "20px", lg: "22px" }} color="gray"><span onClick={() => navigate('/')} style={{ cursor: 'pointer' }} onMouseEnter={e => e.target.style.textDecoration = "underline"} onMouseLeave={e => e.target.style.textDecoration = "none"} > {t("Accueil")}</span>  / <span >{t("Tableau de bord")}</span></Text>

        </>
      ) : (
        <>
          <Text
            display={{ base: 'none', md: "block" }}
            color="black"
            ml={10}
            fontWeight={"bold"}
            fontSize={{ base: "md", sm: "md", md: "xl", lg: "xl", xl: '2xl' }}
          >
            Ecom System
          </Text>
        </>
      )} */}
      <HStack
        justify={"end"}
        shadow={changeBgNavBar === "white" ? "sm" : "lg"}
        rounded={"16px"}
        px={4}
        py={1}
        background={changeBgNavBar === "white" ? navBarBgWhite : navBarBgGlass}
        backdropFilter={"blur(12px) saturate(180%)"}
        WebkitBackdropFilter={"blur(12px) saturate(180%)"}
        position={'fixed'}
        zIndex={999}
        spacing={{ base: "0", md: "4" }}
        border="1px solid"
        borderColor={navBarBorderColor}
        transition="all 0.3s ease"
      >
        {/* {isSiderBar === "block" ?
          <RiMenuFoldLine
            display={{ base: "none", md: 'flex' }}
            color={"black"}
            size={"18px"}
            cursor='pointer'
            onClick={handleCloseSideBar} />
          :
          <RiMenuUnfoldLine
            display={{ base: "none", md: 'flex' }}
            color={"black"}
            size={"18px"}
            cursor='pointer'
            onClick={handleCloseSideBar} />
        }

        <RiMenuFoldLine
          display={{ base: "flex", md: "none" }}
          color={"black"}
          size={"18px"}
          cursor='pointer'
          onClick={onOpen} /> */}
        {isSiderBar === "block" ? (
          <IconButton
            display={{ base: "none", md: "flex" }}
            icon={<RiMenuFoldLine color={colorCondition} />}
            onClick={handleCloseSideBar}
            borderColor={'purple.200'}
            border={"none"}
            variant="outline"

          />
        ) : (
          <IconButton
            display={{ base: "none", md: "flex" }}
            onClick={handleCloseSideBar}
            icon={<RiMenuUnfoldLine color={colorCondition} />}
            borderColor={'purple.200'}
            border={"none"}
            variant="outline"

            aria-label={t("open menu")}

          />
        )}

        <IconButton
          display={{ base: "flex", md: "none" }}
          onClick={onOpen}
          icon={<RiMenuFoldLine color={colorCondition} />}
          borderColor={'purple.200'}
          border={"none"}
          variant="outline"

          aria-label={t("open menu")}

        />

        <LanguageChanger color={colorCondition} />

        {/* Active business chip for client roles */}
        {currentBusiness && ['AdminClient', 'ManagerClient', 'RespoSuiviClient', 'StockManagerClient'].includes(user?.role) && (
          <Flex
            display={{ base: "none", md: "flex" }}
            align="center" gap={2}
            px={3} py={1}
            borderRadius="full"
            bg={bgPurpleColor}
            border="1px solid"
            borderColor={borderPurpleColor}
            cursor="pointer"
            maxW="180px"
            onClick={() => navigate("/select-business")}
            _hover={{ bg: hoverPurpleColor }}
            title={t("Changer de business")}
          >
            <Box w={2} h={2} borderRadius="full" bg={currentBusiness.is_active ? "green.400" : "red.400"} flexShrink={0} />
            <Text fontSize="xs" fontWeight="semibold" color={txtColorPurpleBusinessName} isTruncated>
              {currentBusiness.name}
            </Text>
            <Text fontSize="xs" color={txtColorIconBusiness}>⇄</Text>
          </Flex>
        )}

        {(user?.role === "ManagerClient" || user?.role === "AdminClient") &&
          <Flex pr={{ base: 3, md: 0 }}>

            <ImStatsBars
              fontSize={"20px"}
              color={colorCondition}
              cursor={'pointer'}
              onClick={() => navigate("/statistics")}
            />
          </Flex>}
        {(user?.role === "ManagerClient" || user?.role === "RespoSuiviClient" || user?.role === "StockManagerClient") &&
          <Menu zIndex={"1"}>
            <MenuButton
              background={"transparent"}
              _hover='none'
              position="relative"

            >
              <Box position="relative">
                <IconButton
                  size="md"
                  variant="ghost"
                  color={colorCondition}
                  icon={<MdOutlineNotificationsActive fontSize="22px" />}
                  _hover={{ bg: bg_hover }}
                  borderRadius="full"
                />
                {countNotes > 0 && (
                  <Badge
                    position="absolute"
                    top="1"
                    right="1"
                    colorScheme="purple"
                    variant="solid"
                    borderRadius="full"
                    fontSize="10px"
                    minW="18px"
                    textAlign="center"
                    boxShadow="0 0 0 2px white"
                  >
                    {countNotes < 100 ? countNotes : '+99'}
                  </Badge>
                )}
              </Box>


            </MenuButton>

            <MenuList

              w={{ base: "200px", md: "450px" }}
              maxH="450px"
              overflow="scroll"
              overflowX={'hidden'}
            >
              <Box px={4} py={3} borderBottom="1px solid" borderColor={boderColor_notif}>
                <Flex justify="space-between" align="center">
                  <Text fontWeight="bold" fontSize="md" color={txtColor}>{t("Mes Notes")}</Text>
                  <Badge colorScheme="purple" variant="subtle" borderRadius="full" px={2}>
                    <FormattedNumber value={countNotes} />
                  </Badge>
                </Flex>
              </Box>

              {notes.map((row) => {
                const isRead = row.is_read.includes(user?.id);
                return (
                  <MenuItem
                    key={row.id}
                    p={0}
                    bg="transparent"
                    _hover={{ bg: "transparent" }}
                    _focus={{ bg: "transparent" }}
                  >
                    <Box
                      w="100%"
                      px={4}
                      py={3}
                      cursor="pointer"
                      transition="all 0.2s"
                      bg={isRead ? "transparent" : bg_purple_notif}
                      borderLeft="4px solid"
                      borderColor={isRead ? "transparent" : "purple.500"}
                      _hover={{
                        bg: bg_hover_purple,
                        transform: "translateX(4px)"
                      }}
                      onClick={() => {
                        IsReadNote(row.id);
                        navigate(`/detail-note`, {
                          state: { idNote: row.id }
                        });
                      }}
                    >
                      <Flex direction="column" gap={1}>
                        <Flex justify="space-between" align="start">
                          <Text
                            fontWeight={isRead ? "medium" : "bold"}
                            fontSize="sm"
                            color={isRead ? txtColor : "purple.600"}
                            noOfLines={1}
                          >
                            {row.title}
                            {row.utilisateur_ciblé && (
                              <Text as="span" fontSize="10px" ml={2} color="purple.400" fontWeight="bold">
                                • {t("Personnel")}
                              </Text>
                            )}
                          </Text>
                          {!isRead && (
                            <Box w={2} h={2} borderRadius="full" bg="purple.500" mt={1} />
                          )}
                        </Flex>

                        <Text
                          fontSize="xs"
                          color="gray.500"
                          noOfLines={2}
                          lineHeight="shorter"
                        >
                          {row.content || t("Cliquer pour voir le détail...")}
                        </Text>

                        <Flex justify="end" mt={1}>
                          <Text fontSize="10px" color="gray.400" fontWeight="medium">
                            {new Date(row.date_creation).toLocaleDateString(t('fr-FR'), {
                              day: '2-digit',
                              month: 'short',
                              year: 'numeric'
                            })}
                          </Text>
                        </Flex>
                      </Flex>
                    </Box>
                  </MenuItem>
                );
              })}

              {notes.length === 0 && (
                <Flex direction="column" align="center" justify="center" py={10} px={6}>
                  <Icon as={FaStickyNote} w={8} h={8} color="gray.300" mb={3} />
                  <Text color="gray.500" fontSize="sm" textAlign="center">
                    {t("Il n'y a aucune note pour le moment")}
                  </Text>
                </Flex>
              )}

              <MenuItem justifyContent="center" color={txtColor} onClick={() => navigate("/my-notes")}>
                {t("Afficher tout")} ...
              </MenuItem>
            </MenuList>
          </Menu>
        }
        {(user?.role === "Manager" || user?.role === "RespoSuivi" || user?.role === "StockManager" || user?.role === "AdminClient") &&

          <Menu zIndex={"1"}>
            <MenuButton
              background={"transparent"}
              _hover='none'
              position="relative"

            >
              <Box position="relative">
                <IconButton
                  size="md"
                  variant="ghost"
                  color={colorCondition}
                  icon={<MdOutlineNotificationsActive fontSize="22px" />}
                  _hover={{ bg: bg_hover_blue }}
                  borderRadius="full"
                />
                {count > 0 && (
                  <Badge
                    position="absolute"
                    top="1"
                    right="1"
                    colorScheme="blue"
                    variant="solid"
                    borderRadius="full"
                    fontSize="10px"
                    minW="18px"
                    textAlign="center"
                    boxShadow="0 0 0 2px white"
                  >
                    {count < 100 ? count : '+99'}
                  </Badge>
                )}
              </Box>


            </MenuButton>

            <MenuList

              w={{ base: "200px", md: "450px" }}
              maxH="450px"
              overflow="scroll"
              overflowX={'hidden'}
            >
              <Box px={4} py={3} borderBottom="1px solid" borderColor={boderColor_notif}>
                <Flex justify="space-between" align="center">
                  <Text fontWeight="bold" fontSize="md" color={txtColor}>{t("Mes Notifications")}</Text>
                  <Badge colorScheme="blue" variant="subtle" borderRadius="full" px={2}>
                    <FormattedNumber value={count} />
                  </Badge>
                </Flex>
              </Box>

              {notifs.map((row) => {
                const isRead = row.is_read.includes(user?.id);
                return (
                  <MenuItem
                    key={row.id}
                    p={0}
                    bg="transparent"
                    _hover={{ bg: "transparent" }}
                    _focus={{ bg: "transparent" }}
                  >
                    <Box
                      w="100%"
                      px={4}
                      py={3}
                      cursor="pointer"
                      transition="all 0.2s"
                      bg={isRead ? "transparent" : bg_blue_notif}
                      borderLeft="4px solid"
                      borderColor={isRead ? "transparent" : "blue.500"}
                      _hover={{
                        bg: bg_hover_gray,
                        transform: "translateX(4px)"
                      }}
                      onClick={() => {
                        IsReadNotif(row.id);
                        navigate(`/detail-notification`, {
                          state: { idNotif: row.id }
                        });
                      }}
                    >
                      <Flex direction="column" gap={1}>
                        <Flex justify="space-between" align="start">
                          <Text
                            fontWeight={isRead ? "medium" : "bold"}
                            fontSize="sm"
                            color={isRead ? txtColor : "blue.600"}
                            noOfLines={1}
                          >
                            {row.title}
                          </Text>
                          {!isRead && (
                            <Box w={2} h={2} borderRadius="full" bg="blue.500" mt={1} />
                          )}
                        </Flex>

                        <Text
                          fontSize="xs"
                          color="gray.500"
                          noOfLines={2}
                          lineHeight="shorter"
                        >
                          {row.content || t("Cliquer pour voir le détail...")}
                        </Text>

                        <Flex justify="end" mt={1}>
                          <Text fontSize="10px" color="gray.400" fontWeight="medium">
                            {new Date(row.date_creation).toLocaleDateString(t('fr-FR'), {
                              day: '2-digit',
                              month: 'short',
                              year: 'numeric'
                            })}
                          </Text>
                        </Flex>
                      </Flex>
                    </Box>
                  </MenuItem>
                );
              })}

              {notifs.length === 0 && (
                <Flex direction="column" align="center" justify="center" py={10} px={6}>
                  <Icon as={MdOutlineNotificationsActive} w={8} h={8} color="gray.300" mb={3} />
                  <Text color="gray.500" fontSize="sm" textAlign="center">
                    {t("Il n'y a aucune notification pour le moment")}
                  </Text>
                </Flex>
              )}

              <MenuItem justifyContent="center" color={txtColor} onClick={() => navigate("/my-notifications")}>
                {t("Afficher tout")} ...
              </MenuItem>
            </MenuList>
          </Menu>
        }

        <Flex pr={{ base: 3, md: 0 }}>
          {/* <MdOutlineNotificationsActive
            color={colorCondition}
            size={"18px"}
            cursor={'pointer'}
            onClick={toggleColorMode} /> */}


          {colorMode === "light" ? <FiMoon
            fontSize={"19px"}
            color="black"
            cursor={'pointer'}
            onClick={toggleColorMode} /> :
            <FiSun
              fontSize={"19px"}
              color="#D69E2E"
              cursor={'pointer'}
              onClick={toggleColorMode} />}
        </Flex>

        <Flex px={3} alignItems={"center"}>
          <Menu >
            <MenuButton
              py={4}
              transition="all 0.3s"
              _focus={{ boxShadow: "none" }}
            >
              <HStack>
                <Avatar size={"sm"} src={user?.image ? (user.image.startsWith('http') ? user.image : linkImage + user.image) : undefined} />
                <VStack
                  display={{ base: "none", lg: "flex" }}
                  alignItems="flex-start"
                  spacing="1px"
                  ml="2"
                >
                  <Text fontSize="sm" color={colorCondition}>
                    {user.first_name} {user.last_name}
                  </Text>
                  <Text fontSize="xs" color={useColorModeValue("purple.600", "white")}>
                    {(user.role === "Admin" || user.role === "AdminClient")
                      ? t("Administrateur")
                      : (user.role === "Manager" || user.role === "ManagerClient")
                        ? t("Manager")
                        : (user.role === "RespoSuivi" || user.role === "RespoSuiviClient")
                          ? t("Centre d'appel")
                          : (user.role === "StockManager" || user.role === "StockManagerClient")
                            ? t("Gestionnaire de stock")

                            : ""}
                  </Text>
                </VStack>
                <Box display={{ base: "none", md: "flex" }} color={colorCondition}>
                  <FiChevronDown />
                </Box>
              </HStack>
            </MenuButton>
            <MenuList
              color={useColorModeValue("black", "white")}
              // minW='200px'
              zIndex={9999}
              borderColor={useColorModeValue("gray.100", "gray.700")}
              alignItems={"center"}
              bg={useColorModeValue("gray.100", "gray.700")}
              boxShadow={"xl"}
            >
              <Center mt={3} mb={3}>
                <Avatar size={"xl"} src={user?.image ? (user.image.startsWith('http') ? user.image : linkImage + user.image) : undefined} />
              </Center>

              <MenuItem
                fontSize={'sm'}
                icon={<BiSolidUser size={15} />}
                bg={menuItembg}
                onClick={() => navigate("/profil")}
              >
                {" "}
                {t("Profil")}
              </MenuItem>
              <MenuItem
                fontSize={'sm'}
                icon={<FaUserEdit size={15} />}
                // _hover={{ bg: "gray.200" }}
                bg={menuItembg}
                onClick={() => navigate("/modifier-profil")}
              >
                {" "}
                {t("Mes paramètres")}
              </MenuItem>
              {user.role === "AdminClient" &&
                <MenuItem
                  fontSize={'sm'}
                  icon={<BsHousesFill size={15} />}
                  // _hover={{ bg: "gray.200" }}
                  bg={menuItembg}
                  onClick={() => navigate("/mes-businesses")}
                >
                  {" "}
                  {t("Mes Businesses")}
                </MenuItem>}
              {user.role !== "Admin" &&
                <MenuItem
                  fontSize={'sm'}
                  icon={<BiMessageSquareDetail size={15} />}
                  // _hover={{ bg: "gray.200" }}
                  bg={menuItembg}
                  onClick={() => navigate("/my-tickets")}
                >
                  {" "}
                  {t("Mes tickets")}
                </MenuItem>}

              {/* <MenuItem
                fontSize={'sm'}
                icon={<ImStatsBars size={15} />}
                // _hover={{ bg: "gray.200" }}
                bg={useColorModeValue("gray.100", "gray.700")}
                onClick={() => navigate("/statistics")}
              >
                {" "}
                {t("Statistiques")}
              </MenuItem> */}
              {(user.role === "AdminClient" || user?.role === 'ManagerClient') && <MenuItem
                fontSize={'sm'}
                icon={<MdPayments size={15} />}
                // _hover={{ bg: "gray.200" }}
                bg={menuItembg}
                onClick={() => navigate("/PlansAbonnement")}
              >
                {" "}
                {t("Abonnement")}
              </MenuItem>}
              <MenuDivider borderColor={'gray.300'} />
              <MenuItem
                icon={<BiLogOut size={20} />}
                // _hover={{ bg: "gray.200" }}
                bg={menuItembg}
                onClick={onLogout}
                color={'red.400'}
              >
                {t("Déconnexion")}
              </MenuItem>
            </MenuList>
          </Menu>
        </Flex>
      </HStack>
    </>
  );
  const b = useColorModeValue("linear(to-r, black, gray.700)", "linear(to-l, black, black)");
  const border = useColorModeValue("black", "gray.700");
  return (
    <Box>
      {isSiderBar === "block" ? (
        <Flex
          pt={5}
          ml={{ base: 0, md: "full" }}
          px={{ base: 4, md: 4 }}
          height="20"
          alignItems="center"
          color="white"
          marginLeft={{ base: 0, md: 60, lg: 60 }}
          bgGradient={"transparent"}
          // borderBottomWidth="1px"
          // borderBottomColor={border}
          justifyContent={"end"}
          position={'relative'}
          {...rest}
        >
          {flexContent}
        </Flex>
      ) : (
        <Flex
          pt={5}
          ml={{ base: 0, md: "full" }}
          px={{ base: 4, md: 4 }}
          height="20"
          alignItems="center"
          color="black"
          marginLeft={0}
          bgGradient={"transparent"}
          // borderBottomWidth="1px"
          // borderBottomColor={border}
          justifyContent={"end"}
          {...rest}
        >
          {flexContent}
        </Flex>
      )}

    </Box>
  );
};






